<div class="facility-page">

  <div class="facility-card">

    <!-- TOP SECTION -->
    <div class="row g-0">

      <!-- LEFT IMAGE SECTION -->
      <div class="col-lg-5">

        <div class="gallery-container">

          <ng-image-slider
            [images]="imageObject"

            [autoSlide]="imageObject?.length > 1 ? 1 : 0"

            [infinite]="false"

            [showArrow]="imageObject?.length > 1"

            [imagePopup]="true"

            [imageSize]="{ width: '100%', height: 420 }"

            slideImage="1"

            class="custom-slider"
          >
          </ng-image-slider>

          <div class="gallery-overlay">
            <div class="facility-badge">
              Premium Sports Facility
            </div>
          </div>

        </div>

      </div>

      <!-- RIGHT DETAILS -->
      <div class="col-lg-7">

        <div class="facility-details">

          <div class="facility-header">
            <h1>{{tenant?.tenantName}}</h1>

            <div class="facility-location">
              <i class="bi bi-geo-alt-fill"></i>
              {{ tenant.address?.addressLine1 }}, {{tenant?.address?.city}}
            </div>
          </div>
          <div class="services-section">

            <div class="service-chip"  *ngFor="let service of serviceChips">

              <img
                [src]="service.icon"
                [alt]="service.name"
                class="service-chip-icon"
              >
              <span>
                {{ service.name }}
              </span>

            </div>

          </div>
          <!-- CTA -->
          <button
            class="btn booking-btn"
            (click)="productDetails(id)"
          >
            <i class="bi bi-calendar-check"></i>
            Book Now
          </button>

          <!-- DESCRIPTION -->
          <div class="info-section">

            <h5 class="section-title">
              About Facility
            </h5>

            <div
              class="facility-description"
              [innerHTML]="tenant?.description">
            </div>

          </div>

          <!-- AMENITIES -->
          <div class="info-section">

            <h5 class="section-title">
              Amenities
            </h5>

            <div class="amenities-grid">

              <div
                class="amenity-chip"
                *ngFor="let amenity of rowData"
              >
                <i class="bi bi-check-circle-fill"></i>
                {{amenity.amenityName || amenity.name}}
              </div>

            </div>

          </div>

          <!-- ADDRESS -->
          <div class="info-section">

            <h5 class="section-title">
              Address
            </h5>

            <div class="address-box">

              <i class="bi bi-building"></i>

              <div>
                {{tenant?.address?.addressLine1}}<br>

                <span *ngIf="tenant?.address?.addressLine2">
                  {{tenant?.address?.addressLine2}}<br>
                </span>

                {{tenant?.address?.city}},
                {{tenant?.address?.state}}<br>

                {{tenant?.address?.country}}
                -
                {{tenant?.address?.pinCode}}
              </div>

            </div>

          </div>

          <!-- CONTACT -->
          <div
            class="info-section"
            *ngIf="getAllPhoneNumbers(tenant)"
          >

            <h5 class="section-title">
              Contact
            </h5>

            <div class="contact-box">

              <i class="bi bi-telephone-fill"></i>

              <a
                href="tel:{{tenant?.contactPhoneNumber1}}"
              >
                {{getAllPhoneNumbers(tenant)}}
              </a>

            </div>

          </div>
          <!-- GOOGLE MAP -->
          <div
            class="info-section"
            *ngIf="tenant?.googleMapsLink"
          >

            <h5 class="section-title">
              Location
            </h5>

            <a
              class="google-map-link"
              [href]="tenant?.googleMapsLink"
              target="_blank"
            >
              <img
                src="../../assets/img/icon-google-maps.svg"
                alt="Google Maps"
              />

              <span>GOOGLE MAP</span>
            </a>

          </div>

          <!-- RULES -->
          <div
            class="info-section"
            *ngIf="rules && rules.length > 0"
          >

            <h5 class="section-title">
              Facility Rules
            </h5>

            <div class="rules-container">

              <div
                class="rule-item"
                *ngFor="let rule of rules"
              >

                <div class="rule-icon">
                  <i class="bi bi-shield-check"></i>
                </div>

                <div class="rule-text">
                  {{rule.description}}
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
